<template>
  <div id="ty_buy" class="relativeItem">
    <!--顶部导航-->
    <topnav
      :vuePage="'#ty_buy'"
      :back="1"
      :dark="1"
      :show="1"
      :backcolor="'none'"
      :position="'absolute'"
    ></topnav>

    <!--头图-->
    <div class="top-img relativeItem">
      <img src="../../assets/tyimg/ty(16).png" class="imgBlock noevents-img" />
    </div>

    <!--主体内容-->
    <div class="content">
      <!--顶部文字-->
      <div class="top-text">
        <p class="p1"><i>￥</i>2980</p>
        <p class="p2">主播资格认证特训营</p>
        <p class="p3">时间&nbsp;&nbsp;以开播时间为准&nbsp;&nbsp;<i></i>&nbsp;80课时</p>
        <p class="p4">课程详情</p>
      </div>

      <!--效果说明-->
      <p class="title">直播课程效果不佳</p>
      <ul class="flex-box xiaoguo">
        <li v-for="(n, index) in text1" :key="index">
          <img :src="n.img" class="imgBlock noevents-img" />
          <p>{{ n.text }}</p>
        </li>
      </ul>

      <!--证书介绍-->
      <p class="title">证书介绍</p>
      <div class="intro1">
        <p class="p1">网络视听主播许可证</p>
        <p class="p2">
          网络视听主播许可证是由天颜计划（重庆）教育信息咨询有限公司与北京七彩未来教育咨询有限公司共同合作，受国家广播电视总局广播影视人才交流中心委托在全国普通高校和职业院校以及专业定向人群范围中开展全网络视听主播岗位技能培训，培训完成后，将发放由家广播电视总局广播影视人才交流中心印发的专业岗位技能合格证书。
        </p>
      </div>
      <p class="intro2">
        网络视听主播，是通用型技能，所有专业学生都能学习！
        国家广播电视总局权威证书，行业优先通行证！
      </p>

      <!--培训内容-->
      <p class="title">培训内容</p>
      <p class="content-tip">听得懂、学的会、用得上、做得好！</p>
      <span class="spectitle spec1">政策法规与职业准则、风险控制</span>
      <span class="spectitle spec2">行业通论</span>
      <div class="tl">
        <p v-for="(n, index) in tl" :key="index">{{ n }}</p>
      </div>
      <span class="spectitle spec3">岗位技能</span>
      <div class="skill">
        <div class="d1" :class="{ sort: !show_all }">
          <span v-for="(n, index) in skill" :key="index">{{ n }}</span>
        </div>
        <div class="d2 relativeItem">
          <span v-if="!show_all">.....</span>
          <i
            class="absoluteItem imgBlock centerX"
            :class="{ overturn: show_all }"
            @click="show_all = !show_all"
          ></i>
        </div>
      </div>

      <!--底部图-->
      <div class="bottom-img relativeItem">
        <a class="allA"></a>
        <img srcset="../../assets/tyimg/ty(33).png" src="noevents-img" />
      </div>
    </div>

    <!--底部按钮-->
    <div class="btn-buy flex-box">
      <a href="tel:13036387690" class="imgBlock">客服</a>
      <button @click="showPayWay">立即购买</button>
    </div>

    <!--支付方式弹窗-->
    <div class="tc" v-show="showTc" @click="showTc = false">
      <div class="payway absoluteItem" @click.stop>
        <p class="tips whiteB">提示：微信支付限额最高3000;</p>
        <!--微信内部只显示微信支付-->
        <ul class="outPay whiteB" v-if="inwx">
          <li class="relativeItem" @click="outPay = 0">
            <img class="icon absoluteItem centerY" src="../../assets/pay (3).png" />
            <p class="p1">微信支付</p>
            <p class="p2">使用微信安全支付</p>

            <img
              class="absoluteItem choose centerY"
              src="../../assets/band.png"
              v-if="bandWxPay"
            />

            <img
              class="absoluteItem choose centerY"
              src="../../assets/pay (6).png"
              v-else-if="outPay == 0"
            />
            <img
              class="absoluteItem choose centerY"
              src="../../assets/pay (7).png"
              v-else
            />
          </li>
        </ul>
        <!--微信外部显示列表支付-->
        <ul class="outPay whiteB" v-if="!inwx">
          <li
            class="relativeItem"
            @click="choosePaylist(index)"
            v-for="(n, index) in paylist"
            :key="index"
          >
            <img class="icon absoluteItem centerY" :src="n.icon" />
            <p class="p1">{{ n.name }}</p>
            <p class="p2" v-if="!n.band">使用{{ n.name }}</p>
            <p class="p2" v-else style="color: red">支付限额最高{{ n.quota }}</p>
            <img
              class="absoluteItem choose centerY"
              src="../../assets/band.png"
              v-if="n.band"
            />
            <img
              class="absoluteItem choose centerY"
              src="../../assets/pay (6).png"
              v-else-if="outPay == index"
            />
            <img
              class="absoluteItem choose centerY"
              src="../../assets/pay (7).png"
              v-else
            />
          </li>
        </ul>

        <div class="acB whiteB" @click.stop="r_to_pay">确认支付</div>
        <div id="closeB" class="acB whiteB" @click.stop="showTc = false">取消</div>
      </div>
    </div>

    <!--遮罩层-->
    <div @click="show_close_zz">
      <fszz message="请在浏览器中打开" v-if="showZZ"></fszz>
    </div>
  </div>
</template>

<script>
import fszz from "../me/fszhezhao";
import topnav from "../index/top_nav";

export default {
  name: "ty_buy",
  components: {
    fszz,
    topnav,
  },
  data() {
    return {
      text1: [
        { text: "直播间气氛冷清", img: require("../../assets/tyimg/ty(40).png") },
        { text: "无效沟通耗费精力", img: require("../../assets/tyimg/ty(35).png") },
        { text: "粉丝用户粘性差", img: require("../../assets/tyimg/ty(37).png") },
        { text: "玩法单一 不具备吸引力", img: require("../../assets/tyimg/ty(36).png") },
      ],
      tl: [
        "新媒体发展与数字营销通论",
        "新媒体运营：公域流量与私域流量",
        "内容电商化与电商内容化",
        "从货架电商向直播电商的进化生态",
        "短视频+直播概论",
        "网络视听主播必备的产品经理修养",
        "直播行业商业模式与赢利之道",
      ],
      skill: [
        "底线思维：网络视听主播常见的雷区与坑",
        "网红经济产业图谱与个人IP孵化",
        "全网头部主播成长背后探秘：团队、选品、IP打造",
        "直播主要平台规则解析",
        "数据驱动：直播数据分析方法与常用工具",
        "网络视听主播演说交流能力培养",
        "网络视听主播人设规划与造型设计 直播设备通论",
        "直播基本技巧：从直播脚本创作到直播拍摄、运营",
        "音频生产与音频主播打造",
        "音频赢利模式全解",
        "抖音/快手直播教程",
        "秀场与社交直播教程",
        "直播涨粉策略全解",
        "其他直播平台账号的注册与基本维护",
        "直播公会与主播",
        "抖音主播带货精准赛道TOP10解析",
        "快手主播带货精准赛道TOP10解析",
        "淘宝电商主播成长模式解析",
        "如何做好你的第一场直播",
        "短视频如何为直播引流——直播成交的两步棋",
        "如何用好主流数据分析平台和工具进行直播复盘",
        "从KOC到长尾：企业直播电商新策略",
        "校园vlog",
      ],
      show_all: false, //是否显示全部培训内容
      showTc: false,
      inwx: false, //是否在微信内部
      paylist: [], //支付列表
      outPay: 0, //支付列表的下标
      bandWxPay: false, //禁止微信支付
      info: [], //用户信息
      showZZ: false, //显示提示遮罩层
      jsApiParameters: "", //微信支付需要的数据对象
      order_info: {}, //订单信息
      recheck: true, //是否结束重复检测订单信息的标识
      count: null, //检测支付状态的计时器
      count_num: 0, //重复查询订单的次数 超过10次就提示用户查询失败联系客服
    };
  },
  methods: {
    /**返回到列表主页 */
    go_back() {
      this.$router.go(-1);
    },

    /**关闭/显示遮罩层 */
    show_close_zz() {
      if (!this.$tool.isStr(this.$route.query.token) && !this.ios_wx) {
        //连接上没有token参数时才关闭弹窗
        this.showZZ = false;
      }
    },
    /**在支付列表中选择支付方式 */
    choosePaylist(val) {
      if (!this.paylist[val].band) {
        this.outPay = val;
      }
    },

    //获取个人信息
    getInfo() {
      let _this = this;
      let data = {};
      let api = this.$apis("me");
      this.$jsonp(api, data, (res) => {
        _this.info = res.data.data.result;
      });
    },

    /** 显示外部支付还是内部支付*/
    showPayWay() {
      this.showTc = true;
    },
    /**真正进行支付的方法*/
    r_to_pay(e) {
      e.target.style.background = "#f4f4f4";
      setTimeout(() => {
        e.target.style.background = "#ffffff";
      }, 1000);
      if (this.outPay == 0) {
        //微信支付
        this.wxPay();
      } else {
        //h5的统一支付
        this.payH5all();
      }
    },
    //微信支付
    wxPay() {
      if (this.$tool.inWX()) {
        let usernumber = null;
        usernumber = this.info.usernumber;

        this.$tool.showLoading();
        let money = this.order_info.amount;
        //调取微信api支付
        //获取接口得到微信支付需要的json，然后传给inwxpay文件里面的jsApiParameters
        //再调用inWxPay.pdWeixinJSBridge
        let _this = this;
        let data = {
          extra: usernumber + "_" + money,
          money: money,
          type: "wxh5pay",
          from: "ios",
          return_url: window.location.origin + "/ty_buy",
          order_id: this.order_info.id,
        };
        //wechatpay
        //ty_pay
        this.$jsonp(this.$apis("ty_wechatpay", "app"), data, (res) => {
          if (res.data.data.status == 200) {
            //先在缓存存入一个标识，在支付完成返回该页面时检测支付状态
            _this.$cookie.set_cache("ty_pay_check_id", _this.order_info.id);
            if (res.data.data.type === 1) {
              _this.jsApiParameters = JSON.parse(res.data.data.data);
              _this.pdWeixinJSBridge();
            } else {
              window.location.href = res.data.data.data;
            }
          } else if (res.data.data.status == 499) {
            //需要绑定手机之后再支付
            _this.bind_p = true;
          } else {
            _this.$tool.tip(res.data.data.msg);
          }
          _this.$tool.hiddenLoading();
        });
      } else {
        //使用微信的h5支付
        this.payH5all();
      }
    },
    onBridgeReady() {
      let _this = this;
      var jsApiParameters = _this.jsApiParameters;
      // eslint-disable-next-line
      WeixinJSBridge.invoke("getBrandWCPayRequest", jsApiParameters, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 郑重提示：res.err_msg将在用户支付成功后返回 ok，但并不保证它绝对可靠。
          _this.jsq_count(60);
        } else if (res.err_msg == "get_brand_wcpay_request:fail") {
          //清除缓存标识
          _this.$cookie.set_cache("ty_pay_check_id", "");
          _this.$tool.tip("支付失败！");
        }
      });
    },
    pdWeixinJSBridge() {
      let _this = this;
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", _this.onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", _this.onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", _this.onBridgeReady);
        }
      } else {
        _this.onBridgeReady();
      }
    },

    payH5all() {
      this.$tool.showLoading();
      let _this = this;
      //进行支付
      let payD = {
        amount: this.order_info.amount,
        order_id: this.order_info.id,
        pay_style_id: this.paylist[this.outPay].id,
        return_url: window.location.origin + "/payfinished?type=tyzspay",
      };
      //不在app就不跳转到payfinished页面
      if (this.$cookie.getC("platform") != "app") {
        payD.return_url = window.location.origin + "/ty_buy";
      }

      this.$jsonp(this.$apis("ty_pay", "app"), payD, (res) => {
        _this.$tool.hiddenLoading();
        if (res.data.data.status == 200) {
          //先在缓存存入一个标识，在支付完成返回该页面时检测支付状态
          _this.$cookie.set_cache("ty_pay_check_id", payD.order_id);
          //在app内部进行支付时才调用重复查询的操作
          if (this.$cookie.getC("platform") == "app") {
            _this.jsq_count(90);
          }
          if (res.data.data.isALiPay) {
            let div = document.createElement("div");
            div.innerHTML = res.data.data.data;
            document.body.appendChild(div);
            document.forms[0].submit();
            setTimeout(() => {
              document.body.removeChild(div);
            }, 2000);
          } else {
            window.location.href = res.data.data.data;
          }
        } else {
          _this.$tool.tip(res.data.data.msg);
        }
      });
    },

    /**获取支付列表 */
    getPaylist() {
      let _this = this;
      let data = {
        source: "tianyanweb",
        from: "web",
        money: this.order_info.amount,
      };
      if (this.$tool.isStr(this.$route.query.token)) {
        data.apptoken = this.$route.query.token;
      }
      this.$jsonp(this.$apis("paylist", "app"), data, (res) => {
        if (res.data.data.status == 200) {
          _this.paylist = res.data.data.data;
          for (let i = 0; i < _this.paylist.length; i++) {
            _this.paylist[i].band = false;
          }
          _this.outPay = 0;
        }
      });
    },

    /**获取订单信息 */
    get_order_info() {
      let _this = this;
      let data = {
        order_id: this.$cookie.get_cache("ty_order_id"),
      };
      this.$jsonp(this.$apis("ty_order_info", "app"), data, (res) => {
        _this.order_info = res.data.data.order_info;
        //获取支付列表
        _this.getPaylist();
      });
    },

    /**重复检查支付状态 */
    recheck_status(time) {
      let _this = this;
      let data = {
        order_id: this.$cookie.get_cache("ty_pay_check_id"),
      };
      this.$jsonp(this.$apis("ty_order_info", "app"), data, (res) => {
        _this.count_num++;
        if (res.data.data.order_info.pay_status != 0) {
          //有结果
          _this.$tool.hiddenLoading();
          if (res.data.data.order_info.pay_status == 1) {
            _this.$tool.tip(
              "恭喜您完成主播资质认证缴费，请静候我们官方工作人员与您联系，开展培训事宜",
              "30%"
            );
            setTimeout(() => {
              window.location.replace(`${window.location.origin}/ty_index`);
              // _this.$router.replace({path:"/ty_index"});
            }, 2500);
          } else if (res.data.data.order_info.pay_status == 2) {
            _this.$tool.tipImg("支付失败，请联系客服", "error");
          }
          clearInterval(_this.count);
          _this.recheck = false;
          //在ios的app中不清除
          if (_this.$tool.isAoI == "isiOS" && _this.$cookie.getC("platform") == "app") {
            //不做任何操作
          } else {
            //清除重复检测支付的标识
            _this.$cookie.set_cache("ty_pay_check_id", "");
          }
        } else {
          //没结果
          if (_this.count_num >= time) {
            clearInterval(_this.count);
            _this.$tool.hiddenLoading();
            //在ios的app中不清除
            if (_this.$tool.isAoI == "isiOS" && _this.$cookie.getC("platform") == "app") {
              //不做任何操作
            } else {
              //清除重复检测支付的标识
              _this.$cookie.set_cache("ty_pay_check_id", "");
            }
          }
        }
      });
    },

    /**查看订单支付状态的计时器 */
    jsq_count(time) {
      //查看缓存是否有重复检测订单支付状态的标识
      this.count_num = 0;
      let _this = this;
      _this.$tool.showLoading();
      _this.count = setInterval(() => {
        _this.recheck_status(time);
      }, 1000);
    },
  },
  created() {
    this.inwx = this.$tool.inWX();
  },
  mounted: function () {
    this.$tool.setTitle("天颜课程购买");
    this.inwx = this.$tool.inWX();
    this.get_order_info();
    //安卓app内部取消银联支付
    if (this.$tool.inWhere("Android")) {
      this.ylpay = false;
    }
    if (this.$tool.isStr(this.$cookie.get_cache("ty_pay_check_id"))) {
      this.jsq_count(10);
    }
  },
};
</script>

<style scoped>
#ty_buy {
  background: url("../../assets/tyimg/ty(4).jpg") left top no-repeat #210a7e;
  background-size: 100%;
  overflow: hidden;
  padding-bottom: 70px;
}
.top-img {
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
}
/**顶部文字 */
.top-text {
  padding-left: 15px;
  color: #fff;
}
.top-text .p1 {
  font-size: 28px;
  color: #fff;
  vertical-align: text-bottom;
}
.top-text .p1 i {
  font-style: normal;
  font-size: 13px;
}
.top-text .p2 {
  font-size: 20px;
  margin: 11px 0;
}
.top-text .p3 {
  font-size: 15px;
}
.top-text .p3 i {
  display: inline-block;
  width: 1px;
  height: 8px;
  border-left: 1px solid rgba(255, 255, 255, 0.8);
  transform: translateY(-20%);
}
.top-text .p4 {
  font-size: 19px;
  margin: 25px 0;
}
/**标题 */
.title {
  font-size: 18px;
  color: #fff;
  padding-left: 15px;
  background: url("../../assets/tyimg/ty(38).png") left center no-repeat;
  background-size: auto 100%;
}
/**效果 */
.xiaoguo {
  padding: 0 9.5%;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 21px;
}
.xiaoguo li {
  width: 48%;
  margin-bottom: 15px;
}
.xiaoguo p {
  border-radius: 8px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  background: linear-gradient(to bottom, #bab5ff, #804aff);
  padding: 6px;
  margin-top: 5px;
}
.xiaoguo img {
  width: 49px;
  height: 49px;
  margin: 0 auto;
}

/**证书介绍 */
.intro1 {
  border-radius: 9px;
  overflow: hidden;
  width: 87%;
  margin: 20px auto 9px auto;
  border: 1px solid #d0c9ff;
}
.intro1 .p1 {
  font-size: 1.125;
  text-align: center;
  color: #814bff;
  background: #d0c9ff;
  padding: 7px;
}
.intro1 .p2 {
  text-indent: 2em;
  font-size: 12px;
  color: #fff;
  padding: 12px 10px;
  text-align: justify;
  line-height: 16px;
}
.intro2 {
  width: 80%;
  margin: 0 auto;
  text-align: center;
  color: #a281ff;
  font-size: 12px;
  margin-bottom: 16px;
}

/**培训内容 */
.content-tip {
  text-align: center;
  border-radius: 3rem;
  font-size: 14px;
  padding: 9px 0;
  width: 75%;
  color: #824eff;
  border: 1px solid #824eff;
  margin: 0 auto;
  margin-top: 22px;
  margin-bottom: 9px;
}
.spectitle {
  display: block;
  padding-top: 16px;
  padding-left: 4px;
  font-size: 14px;
  color: #fff;
  margin-left: 15px;
}
.spec1 {
  background: url("../../assets/tyimg/ty(41).png") left top no-repeat;
  background-size: 38px;
}
.spec2 {
  background: url("../../assets/tyimg/ty(43).png") left top no-repeat;
  background-size: 38px;
  margin: 15px 0 12px 15px;
}
.spec3 {
  background: url("../../assets/tyimg/ty(42).png") left top no-repeat;
  background-size: 38px;
  margin: 12px 0 12px 15px;
}
.tl {
  width: 90%;
  border-radius: 8px;
  border: 1px solid #fff;
  padding: 14px 10px;
  font-size: 12px;
  color: #fff;
  margin: 0 auto;
}
.tl p {
  margin-bottom: 1px;
}
.skill {
  width: 90%;
  margin: 0 auto;
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #fff;
  padding: 8px 10px;
  padding-bottom: 0;
  font-size: 12px;
  color: #fff;
  overflow: hidden;
  background: #210a7e;
}
.skill .d1 {
  transition: all 0.3s;
  height: 390px;
}
.skill .d1 span {
  display: block;
  margin-bottom: 1px;
}
.skill .sort {
  height: 120px;
  overflow: hidden;
}
.skill .d2 {
  padding-top: 2px;
  height: 40px;
  background: #210a7e;
}
.skill .d2 i {
  width: 0;
  height: 0;
  border-top: 9px solid #a76dff;
  border-right: 9px solid transparent;
  bottom: 10px;
  transform: rotateZ(-135deg);
  transition: all 0.3s;
}
.skill .d2 .overturn {
  transform: rotateZ(45deg);
}

.bottom-img {
  width: 90%;
  margin: 0 auto;
}

/**底部按钮 */
.btn-buy {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  background: #fff;
  align-items: center;
  padding: 7px;
  padding-left: 15px;
  justify-content: space-between;
}
.btn-buy a {
  font-size: 10px;
  padding-top: 23px;
  width: 30px;
  color: #333;
  background: url("../../assets/tyimg/ty(39).png") center top no-repeat;
  background-size: 21px;
  text-align: center;
}
.btn-buy button {
  background: linear-gradient(to right, #ff7d62, #ff3b29);
  color: #fff;
  border-radius: 6px;
  width: 88%;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  padding: 10px 0;
}

/*支付方式*/
.payway {
  width: 100%;
  bottom: 0;
  left: 0;
  animation: show 0.8s;
  padding: 0 !important;
  -webkit-animation: show 0.8s;
  /* Safari 和 Chrome */
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.payway .acB {
  padding: 0.9rem 0;
  text-align: center;
  font-size: 16px;
  border-bottom: 1px solid #f5f5f5;
}
.payway .acB:last-child {
  margin: 0;
}
.payway .bottomClicked {
  background: #f4f4f4;
  box-shadow: 0 1px 11px rgba(0, 0, 0, 0.1) inset;
}
.tips {
  padding: 0.5rem 1rem;
  font-size: 13px;
  color: #999;
}
.outPay {
  border-bottom: 1px solid #f4f4f4;
}
.outPay p {
  text-align: left;
}
.outPay li {
  padding: 0.5rem 3.8rem;
  width: 100%;
  text-align: left;
}
.outPay .p1 {
  font-size: 14px;
  font-weight: 400;
  margin: 0;
}
.outPay .p2 {
  font-size: 12px;
  font-weight: 400;
  color: #999;
}
.outPay .warning {
  color: #ff7675;
}
.outPay .icon {
  width: 2.4rem;
  height: 2.4rem;
  left: 1rem;
}
.outPay .choose {
  right: 1rem;
  width: 16px;
  height: 16px;
}
</style>
